import { getCheckoutToCancelId, removeCheckoutToCancelId } from '../checkout-to-cancel-handler'
import { checkoutV2Service } from '../services'

export function handleCheckoutCancellation(): Promise<void> {
  const checkoutToCancelId = getCheckoutToCancelId()

  if (checkoutToCancelId) {
    removeCheckoutToCancelId()
    return checkoutV2Service.cancelCheckout(checkoutToCancelId)
  }

  return Promise.resolve()
}
